import { takeLatest, put, call, select } from 'redux-saga/effects';
import {
    GET_DEALERS_REQUEST,
    getDealersFailure,
    getDealersSuccess
} from '../actions/dealers';
import { getDealers } from '../services/dealers';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';

export const getDealersWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);

        const { data: { dealers } } = yield call(getDealers, filters, token);
        yield put(getDealersSuccess(dealers));
    } catch (err) {
        yield put(getDealersFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [
    takeLatest(GET_DEALERS_REQUEST, getDealersWorker)
];
